import { ChangeDetectionStrategy, Component, Input, ViewChild } from "@angular/core";
import { S25ModalComponent } from "../../s25-modal/s25.modal.component";
import { TypeManagerDecorator } from "../../../main/type.map.service";
import { EventReqInfo } from "../../../services/avail.service";
import { PopoverComponent } from "../../s25-popover/popover.component";
@TypeManagerDecorator("s25-ng-opt-waitlist-button")
@Component({
    selector: "s25-ng-opt-waitlist-button",
    template: `
        @if (!showIncludeRequested) {
            <s25-popover
                [popoverTemplate]="popoverWlContent"
                [openTrigger]="'click'"
                [closeTrigger]="'click'"
                (mouseenter)="popoverWl.forceOpen()"
                (mouseleave)="popoverWl.forceClose()"
            >
                <button class="aw-button aw-button--outline" [disabled]="!showIncludeRequested">
                    Manage Conflicts
                </button>
            </s25-popover>
            <ng-template #popoverWlContent>
                <div>Please check 'Include Requested' to view competing requests.</div>
            </ng-template>
        } @else {
            <button
                (click)="openModal(waitlistModal)"
                (keyup.enter)="openModal(waitlistModal)"
                class="aw-button aw-button--outline"
                [disabled]="!showIncludeRequested"
            >
                Manage Conflicts
                <s25-ng-icon [type]="'queue'" [label]="'Manage Conflicts'">></s25-ng-icon>
            </button>
        }

        <s25-ng-modal #waitlistModal [title]="'Tasks By Location'" [size]="'xl'">
            <ng-template #s25ModalBody>
                @if (waitlistEventIds?.length > 0) {
                    <s25-ng-manage-task
                        [data]="{ eventIds: waitlistEventIds, waitlistEvents: waitlistEvents }"
                    ></s25-ng-manage-task>
                } @else {
                    <p>None</p>
                }
            </ng-template>
        </s25-ng-modal>
    `,
    styles: `
        :host {
            align-self: flex-end;
        }

        a {
            top: -0.1em;
        }

        button {
            display: inline-flex;
            align-items: center;
            gap: 0.5rem;
        }

        s25-ng-icon {
            display: inline-flex;
        }
    `,
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false,
})
export class S25OptWaitlistButtonComponent {
    @ViewChild(PopoverComponent) popoverWl: PopoverComponent;
    @Input() waitlistEventIds?: number[];
    @Input() waitlistEvents?: EventReqInfo[];
    @Input() showIncludeRequested?: boolean;
    openModal(modal: S25ModalComponent) {
        return modal.open();
    }
}
